import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { ExtendedGroup, RenameGroupGroupData, UserInput } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function group(config) {
    const addMemberResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedGroup)),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedGroup)),
    });
    const removeMemberResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedGroup)),
    });
    const renameGroupResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedGroup)),
    });
    return Object.freeze({
        /**
         * Add a user (member) to a group.
         *
         * @param arg The arguments to the function.
         * @param arg.groupId The id of the group the user should be added to.
         * @param arg.requestBody The body of the request.
         * @returns The group with the newly added user.
         */
        addMember: async ({ groupId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/groups/${groupId}/member`, addMemberResponse.v, JSON.stringify(UserInput.encode(requestBody)));
            return result;
        },
        /**
         * Delete a group by id.
         *
         * This action is irreversible!
         *
         * This is only possible if the group doesn't have any submissions associated with it.
         *
         * @param arg The arguments to the function.
         * @param arg.groupId The id of the group to delete.
         * @returns Nothing.
         */
        delete: async ({ groupId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/groups/${groupId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get a group by id.
         *
         * @param arg The arguments to the function.
         * @param arg.groupId The id of the group to get.
         * @returns The requested group.
         */
        get: async ({ groupId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/groups/${groupId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Remove a member from a group.
         *
         * If the group has a submission you cannot delete the last remaining member of a group.
         *
         * @param arg The arguments to the function.
         * @param arg.groupId The group the user should be removed from.
         * @param arg.userId The user that should be removed.
         * @returns The group without the removed user.
         */
        removeMember: async ({ groupId, userId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/groups/${groupId}/members/${userId}`, removeMemberResponse.v, undefined);
            return result;
        },
        /**
         * Update the name of the group.
         *
         * @param arg The arguments to the function.
         * @param arg.groupId The id of the group that should be updated.
         * @param arg.requestBody The body of the request.
         * @returns The group with the updated name.
         */
        renameGroup: async ({ groupId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/groups/${groupId}/name`, renameGroupResponse.v, JSON.stringify(RenameGroupGroupData.encode(requestBody)));
            return result;
        },
    });
}
